import React, { type FC } from "react";
import { BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { ListItem } from "@src/components/business-list";
import { BusinessList } from "@src/components/business-list";
import { BalanceDocType } from "../../../../../../../../types/business/balanceDocType";
import type { UseWsInplantContentsQueryResult } from "../../hooks/useWsInplantContentsQuery";

interface WsInplantConentListProps {
    contentsQuery: UseWsInplantContentsQueryResult;
    /** Тип баланса документа. Расходный или приходный. */
    docType: BalanceDocType;
    readonly: boolean;
    onCreate: () => void;
    onOpenContent: (contentCode: number) => void;
}

/**
 * Список содержимого (состава) ВЗН УП для карточки ВЗН.
 */
export const WsInplantConentList: FC<WsInplantConentListProps> = ({
    contentsQuery,
    docType,
    readonly,
    onCreate,
    onOpenContent,
}) => {
    const { contents, isFetching } = contentsQuery;

    return (
        <BusinessList
            isLoad={isFetching}
            hoodBtns={[
                {
                    text: "Создать",
                    srcIcon: "/images/common/plus.svg",
                    hide: readonly || docType === BalanceDocType.Arrival,
                    onClick: onCreate,
                },
            ]}
        >
            {contents.map((content) => {
                const stockObj = content.LeaveCard?.Stockobj;
                const leaveCard = content.LeaveCard;

                return (
                    <ListItem
                        key={content.Code}
                        title={<BusinessStockObjValue stockObj={stockObj} />}
                        props={[
                            {
                                label: "Выдано",
                                value: <BusinessMeasureValue value={content.LeaveQty} measure={leaveCard?.Measure} />,
                            },
                            {
                                label: "Получено",
                                value: <BusinessMeasureValue value={content.ArrivalQty} measure={leaveCard?.Measure} />,
                            },
                        ]}
                        onClick={() => {
                            onOpenContent(content.Code);
                        }}
                    />
                );
            })}
        </BusinessList>
    );
};
